import { render, staticRenderFns } from "./IconSwap.vue?vue&type=template&id=407bcf02&scoped=true"
import script from "./IconSwap.vue?vue&type=script&lang=js"
export * from "./IconSwap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407bcf02",
  null
  
)

export default component.exports